import React from 'react';
import { Paper, Box, Typography, Button } from '@mui/material';

/**
 * Reusable empty state.
 * @param icon          MUI icon component (e.g. PeopleIcon)
 * @param title         short headline
 * @param description   optional supporting line
 * @param actionLabel + onAction  optional primary CTA (omit both to hide)
 * @param variant       'empty' (no data yet) | 'no-results' (filter/search miss)
 * @param dense         smaller padding for use inside tables/cards
 */
export default function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  variant = 'empty',
  dense = false,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: dense ? 4 : 6,
        textAlign: 'center',
        border: '1px dashed',
        borderColor: 'grey.300',
        bgcolor: variant === 'no-results' ? 'grey.50' : 'background.paper',
        borderRadius: 3,
      }}
    >
      {Icon && (
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
          <Icon sx={{ fontSize: dense ? 48 : 64, color: 'text.disabled' }} />
        </Box>
      )}
      <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.secondary' }}>
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" sx={{ color: 'text.disabled', mt: 1, maxWidth: 420, mx: 'auto' }}>
          {description}
        </Typography>
      )}
      {actionLabel && onAction && (
        <Button variant="contained" onClick={onAction} sx={{ mt: 3 }}>
          {actionLabel}
        </Button>
      )}
    </Paper>
  );
}
